import {NavigationContainer} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import React from 'react';
import {Platform} from 'react-native';
import {linking} from '../../data/constants/navigation';
import {StackParams} from '../../data/types/navigation';
import {Home} from '../screens';
import DetailContratRapatriement from '../screens/AssuranceRapatriement/Details';
import {DemanderDevisAssuranceRapatriement} from '../screens/AssuranceRapatriement/Devis/Demande';
import {SouscriptionAssuranceRapatriement} from '../screens/AssuranceRapatriement/Souscription';
import {SouscriptionAssuranceRCVP} from '../screens/AssuranceRCVP/';
import {SimulationCotisation} from '../screens/AssuranceRetraite/Devis/';
import {ResultatSimulationCapital} from '../screens/AssuranceRetraite/Devis/Resultat/Capital';
import {ResultatSimulationCotisation} from '../screens/AssuranceRetraite/Devis/Resultat/Cotisation';
import {ResultatSimulationPension} from '../screens/AssuranceRetraite/Devis/Resultat/Pension';
import {SouscriptionAssuranceRetraite} from '../screens/AssuranceRetraite/Souscription';
import {SouscriptionAssuranceScolaire} from '../screens/AssuranceScolaire/Souscription/index.web';
import DetailContratVoyage from '../screens/AssuranceVoyage/Details';
import {DemanderDevisAssuranceVoyage} from '../screens/AssuranceVoyage/Devis/Demande';
import {ListDevisAssuranceVoyage} from '../screens/AssuranceVoyage/Devis/Liste';
import {ModificationAssuranceVoyage} from '../screens/AssuranceVoyage/Modification';
import {ResiliationAssuranceVoyage} from '../screens/AssuranceVoyage/Resiliation';
import {SouscriptionAssuranceVoyage} from '../screens/AssuranceVoyage/Souscription';
import {SouscriptionMenuVoyage} from '../screens/AssuranceVoyage/Souscription/Menu/SouscriptionMenu';
import {CatalogueProduit} from '../screens/Catalogue';
import {ChatBot} from '../screens/ChatBot';
import {DetailContrat} from '../screens/Contrat/DetailContrat';
import {MesContrats} from '../screens/Contrat/MesContrats';
import {SouscrireContrat} from '../screens/Contrat/SouscriptionContrat';
import {EpargneEtPrevoyanceContrat} from '../screens/Contrat/SouscriptionContrat/EpargneEtPrevoyanceContrat';
import {FamilleContrat} from '../screens/Contrat/SouscriptionContrat/Famille';
import {DemanderAvenant} from '../screens/DemanderAvenant';
import {DemanderDevis} from '../screens/DemanderDevis';
import {DemandeRdv} from '../screens/DemandeRDV';
import {DemanderSimulation} from '../screens/DemanderSimulation';
import DemanderSimulationFamille from '../screens/DemanderSimulation/Famille';
import {AssuranceGenerale} from '../screens/DemanderSimulation/General';
import {DemarcheCategorie} from '../screens/DemarcheCategorie';
import {DetailsDemarche} from '../screens/DetailsDemarche';
import {FAQ} from '../screens/FAQ';
import {Glossaire} from '../screens/Glossaire';
import {Inscription} from '../screens/Inscription';
import {Lexique} from '../screens/Lexique';
import {Login} from '../screens/Login';
import {MesSinistres} from '../screens/MesSinistres';
import {AccidentVoyageSinistre} from '../screens/MesSinistres/AccidentVoyage';
import {AutoMotoSinistre} from '../screens/MesSinistres/AutoMoto';
import {DeclarerSinistre} from '../screens/MesSinistres/DeclarerSinistre';
import {DetailSinistre} from '../screens/MesSinistres/DetailSinistre';
import {FamilleSinistre} from '../screens/MesSinistres/Famille';
import {Habitation} from '../screens/MesSinistres/Habitation';
import {MonEspace} from '../screens/MonEspace';
import {MonProfil} from '../screens/MonProfil';
import NewFeatures from '../screens/NewFeatures';
import {Notification} from '../screens/Notification';
import {DetailNotification} from '../screens/Notification/DetailNotification';
import {Payement} from '../screens/Paiement';
import {AirtelPayment} from '../screens/Paiement/AirtelPayment';
import {CbPayment} from '../screens/Paiement/CbPayment';
import {ComptantPayment} from '../screens/Paiement/ComptantPayment';
import {PayementList} from '../screens/Paiement/List';
import {OrangePayment} from '../screens/Paiement/OrangePayment';
import {TelmaPayment} from '../screens/Paiement/TelmaPayment';
import {PaymentWebView} from '../screens/Paiement/WebViewPayment';

const title = (text: string) => Platform.select({web: text, default: text});

const Stack = createStackNavigator<StackParams>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Navigation(props: any) {
  const {refNavigation} = props;
  return (
    <NavigationContainer ref={refNavigation} linking={linking}>
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
        }}>
        <Stack.Screen
          name="Home"
          component={Home}
          options={{title: title('Accueil')}}
        />
        <Stack.Screen
          name="Inscription"
          component={Inscription}
          options={{title: title('Inscription')}}
        />
        <Stack.Screen
          name="Produit"
          component={CatalogueProduit}
          options={{title: title('Catalogue de Produits')}}
        />
        <Stack.Screen
          name="Lexique"
          component={Lexique}
          options={{title: title('Lexique')}}
        />
        <Stack.Screen
          name="Glossaire"
          component={Glossaire}
          options={{title: title('Glossaire')}}
        />
        <Stack.Screen
          name="DemarcheCategorie"
          component={DemarcheCategorie}
          options={{title: title('Les Démarches')}}
        />
        <Stack.Screen
          name="Details"
          component={DetailsDemarche}
          options={{title: title('Détails')}}
        />
        <Stack.Screen
          name="DemanderSimulation"
          component={DemanderSimulation}
          options={{title: title('Demander simulation')}}
        />
        <Stack.Screen
          name="DemanderSimulationFamille"
          component={DemanderSimulationFamille}
          options={{title: title('Demander Simulation')}}
        />
        <Stack.Screen
          name="AssuranceScolaire"
          component={AssuranceGenerale}
          options={{title: title('Demander simulation')}}
        />
        <Stack.Screen
          name="DemanderDevisAssuranceVoyage"
          component={DemanderDevisAssuranceVoyage}
          options={{title: title('Demander un devis')}}
        />
        <Stack.Screen
          name="Cotisation"
          component={SimulationCotisation}
          options={{title: title('Demander simulation')}}
        />
        <Stack.Screen
          name="ResultatCapital"
          component={ResultatSimulationCapital}
          options={{title: title('Demander simulation')}}
        />
        <Stack.Screen
          name="ResultatCotisation"
          component={ResultatSimulationCotisation}
          options={{title: title('Demander simulation')}}
        />
        <Stack.Screen
          name="ResultatPension"
          component={ResultatSimulationPension}
          options={{title: title('Demander simulation')}}
        />
        {/* End Simulation */}
        <Stack.Screen
          name="FAQ"
          component={FAQ}
          options={{title: title('FAQ')}}
        />
        <Stack.Screen
          name="DemandeRdv"
          component={DemandeRdv}
          options={{title: title('Demander un rendez-vous')}}
        />
        <Stack.Screen
          name="Login"
          component={Login}
          options={{title: title('Connexion')}}
        />
        <Stack.Screen
          name="MonEspace"
          component={MonEspace}
          options={{title: title('Mon espace')}}
        />
        <Stack.Screen
          name="MonProfil"
          component={MonProfil}
          options={{title: title('Mon profil')}}
        />
        <Stack.Screen
          name="ChatBot"
          component={ChatBot}
          options={{title: title('ChatBot')}}
        />
        <Stack.Screen
          name="SouscrireContrat"
          component={SouscrireContrat}
          options={{title: title('Souscription à un contrat')}}
        />
        <Stack.Screen
          name="FamilleContrat"
          component={FamilleContrat}
          options={{title: title('Souscription à un contrat')}}
        />
        <Stack.Screen
          name="EpargneEtPrevoyanceContrat"
          component={EpargneEtPrevoyanceContrat}
          options={{title: title('Souscription à un contrat')}}
        />
        <Stack.Screen
          name="SouscriptionAssuranceScolaireForm"
          component={SouscriptionAssuranceScolaire}
          options={{title: title('Souscription à une assurance scolaire')}}
        />
        <Stack.Screen
          name="SouscriptionAssuranceRetraiteForm"
          component={SouscriptionAssuranceRetraite}
          options={{title: title('Souscription à une assurance retraite')}}
        />
        <Stack.Screen
          name="SouscriptionAssuranceRCVPForm"
          component={SouscriptionAssuranceRCVP}
          options={{title: title('Souscription à une assurance RCVP')}}
        />
        <Stack.Screen
          name="DemanderDevis"
          component={DemanderDevis}
          options={{title: title('Demander un devis')}}
        />
        <Stack.Screen
          name="MesContrats"
          component={MesContrats}
          options={{title: title('Mes contrats')}}
        />
        <Stack.Screen
          name="DetailContrat"
          component={DetailContrat}
          options={{title: title('Détails du contrat')}}
        />
        <Stack.Screen
          name="ListDevisAssuranceVoyage"
          component={ListDevisAssuranceVoyage}
          options={{title: title('Liste attente souscription')}}
        />
        <Stack.Screen
          name="SouscriptionAssuranceVoyage"
          component={SouscriptionAssuranceVoyage}
          options={{title: title('Souscription à une assurance RCVP')}}
        />
        <Stack.Screen
          name="SouscriptionMenuVoyage"
          component={SouscriptionMenuVoyage}
          options={{title: title('Assurance voyage')}}
        />
        <Stack.Screen
          name="DemanderDevisAssuranceRapatriement"
          component={DemanderDevisAssuranceRapatriement}
          options={{title: title('Demander un devis')}}
        />

        <Stack.Screen
          name="SouscriptionAssuranceRapatriement"
          component={SouscriptionAssuranceRapatriement}
          options={{title: title('Assurance Obsèques à Dago')}}
        />
        <Stack.Screen
          name="DetailContratRapatriement"
          component={DetailContratRapatriement}
          options={{title: title('Detail Contrat Assurance obsèques à dago')}}
        />
        <Stack.Screen
          name="Notification"
          component={Notification}
          options={{title: title('Notification')}}
        />
        <Stack.Screen
          name="DetailNotification"
          component={DetailNotification}
          options={{title: title('Detail sur la notification')}}
        />

        {/* Paiement */}
        <Stack.Screen
          name="Payement"
          component={Payement}
          options={{title: title('Payement')}}
        />
        <Stack.Screen
          name="AirtelPayment"
          component={AirtelPayment}
          options={{title: title('Paiement Airtel')}}
        />
        <Stack.Screen
          name="OrangePayment"
          component={OrangePayment}
          options={{title: title('Paiement Orange Money')}}
        />
        <Stack.Screen
          name="TelmaPayment"
          component={TelmaPayment}
          options={{title: title('Paiement Mvola')}}
        />
        <Stack.Screen
          name="CbPayment"
          component={CbPayment}
          options={{title: title('Paiement par carte bancaire')}}
        />
        <Stack.Screen
          name="ComptantPayment"
          component={ComptantPayment}
          options={{title: title('Paiement en comptant')}}
        />
        <Stack.Screen
          name="PayementList"
          component={PayementList}
          options={{title: title('Liste paiement')}}
        />
        <Stack.Screen
          name="PaymentWebView"
          component={PaymentWebView}
          options={{title: title('Paiement')}}
        />

        <Stack.Screen
          name="MesSinistres"
          component={MesSinistres}
          options={{title: title('Mes sinistres')}}
        />
        <Stack.Screen
          name="DeclarerSinistre"
          component={DeclarerSinistre}
          options={{title: title('Déclarer sinistre')}}
        />
        <Stack.Screen
          name="AutoMotoSinistre"
          component={AutoMotoSinistre}
          options={{title: title('Auto-moto sinistre')}}
        />
        <Stack.Screen
          name="FamilleSinistre"
          component={FamilleSinistre}
          options={{title: title('Famille sinistre')}}
        />
        <Stack.Screen
          name="HabitationSinistre"
          component={Habitation}
          options={{title: title('Habitation sinistre')}}
        />
        <Stack.Screen
          name="AccidentVoyageSinistre"
          component={AccidentVoyageSinistre}
          options={{title: title('Accident de voyages sinistre')}}
        />
        <Stack.Screen
          name="DetailSinistre"
          component={DetailSinistre}
          options={{title: title('Detail sinistre')}}
        />
        <Stack.Screen
          name="DetailContratVoyage"
          component={DetailContratVoyage}
          options={{title: title('Detail Contrat Voyage')}}
        />
        <Stack.Screen
          name="ModificationAssuranceVoyage"
          component={ModificationAssuranceVoyage}
          options={{title: title('Detail Contrat Voyage')}}
        />
        <Stack.Screen
          name="ResiliationAssuranceVoyage"
          component={ResiliationAssuranceVoyage}
          options={{title: title('Detail Contrat Voyage')}}
        />
        <Stack.Screen
          name="DemanderAvenant"
          component={DemanderAvenant}
          options={{title: title('Demander un avenant')}}
        />
        <Stack.Screen
          name="NewFeatures"
          component={NewFeatures}
          options={{title: title('Nouvelle Fonctionalités')}}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
}
